import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { PageWrapper } from '../../../../atoms/PageWrapper';
import { NotFoundPage } from '../../../public/NotFound';
import { Loader } from '../../../../molecules/Loader';
import { ChapterDetailContent } from './ChapterDetailContent';
import { useGetChapterQuery } from '../../../../../gen/graphql';
import { ApolloUtil } from '../../../../../utils/ApolloUtil';

/**
 * 権限確認なしで章の内容を表示する教材情報にアクセスする画面
 * hcmufw という文字列は特に意味を持たない。
 * 権限確認なしで教材情報にアクセスする画面を識別するための文字列として使用している。
 */
export function ChapterDetailForHcmufw(): React.ReactElement {
  const params = useParams<{ chapter_id: string }>();
  const pathChapterID = Number(params.chapter_id);
  if (Number.isNaN(pathChapterID)) return NotFoundPage;

  return <Internal chapterID={pathChapterID} />;
}

interface Props {
  chapterID: number;
}

export function Internal(props: Props): React.ReactElement {
  // 章を取得する。
  const chapterData = ApolloUtil.toQueryResult(
    useGetChapterQuery({
      variables: { chapterID: props.chapterID, includeExam: false, flag: false },
    }),
  );

  // 何らかの理由により教材データを取得できない場合は Not Found を表示する。
  if (!chapterData.chapter && !chapterData.loading) {
    return NotFoundPage;
  }

  // マークダウンテキスト内の相対パスのリンクを無効化する。
  let chapter: typeof chapterData.chapter = null;
  if (chapterData.chapter) {
    chapter = { ...chapterData.chapter };
    chapter.content = stripRelativeLinks(chapterData.chapter.content ?? '');
  }

  return (
    <>
      <Loader display={chapterData.loading} />

      <PageWrapper>
        <Main>
          <ChapterDetailContent
            programID={0 /* Yoshinaでは教材IDは使用しないので 0 を渡しておく。 */}
            chapterID={props.chapterID}
            program={undefined}
            chapter={chapter}
            programExam={undefined}
            studyLog={undefined}
            refetchStudyLog={undefined}
            openCompleteModal={() => {
              /* */
            }}
            hasPermissionToReadStudyLog={false}
            hasPermissionToReadExam={false}
            hasPermissionToReadExamForInstructorAndCoach={false}
            isLoggedIn={false}
            personalInfoVisible={false}
            programElementsVisible={false}
          />
        </Main>
      </PageWrapper>
    </>
  );
}

/** 相対パスのリンクを通常のテキストに変換する。"[リンクテキスト](/相対パス)" → "リンクテキスト"。
 * @param markdownText マークダウンテキスト
 * @returns 相対パスのアンカーリンクを無効化したマークダウンテキスト
 */
function stripRelativeLinks(markdownText: string): string {
  return markdownText.replace(/\[(.+?)\]\((\s*\/.+?)\)/g, '$1');
}

const Main = styled.div`
  transition: all 0.2s;
`;
